<template>
  <div class="toolbar-workbook" ref="toolbar">
    <div
      v-for="item in cachedToolbarItems"
      :key="item.nameCommmand"
      :class="'item_' + item.code"
      v-show="!item.isHidden"
    >
      <toolbarItemWorkbook
        v-if="item.type !== 4"
        class="item_toolbar"
        :toolbar="item"
        :range-style="rangeStyle"
        @toolbarEvent="toolbarEvent"
      >
      </toolbarItemWorkbook>

      <div v-else class="group_toolbar">
        <div class="header_group" @click="hiddenMenu(item.code)" v-tooltip="item.toolTip">
          <div :class="item.icon"></div>
          <!-- <div class="title">{{}}</div> -->
          <div class="icon24 down-group size-icon_custom"></div>
        </div>
        <transition>
          <div class="item_group" v-show="item.code == codeGroup">
            <toolbarItemWorkbook
              v-for="itemGroup in item.subItems"
              :key="itemGroup.nameCommmand"
              class="item_toolbar"
              :toolbar="itemGroup"
              :range-style="rangeStyle"
              @toolbarEvent="toolbarEvent"
            >
            </toolbarItemWorkbook>
          </div>
        </transition>
      </div>
    </div>
    <div class="header_group more_item" ref="moreToolbar">
      <div class="icon24 more-icon" @click="toggleDropdown" v-tooltip="'Thêm'" v-show="hasHiddenItems"></div>
      <div class="toolbar-more_items" :style="'left:' + leftToolbar + 'px'" v-show="dropdownVisible">
        <div v-for="item in hiddenItems" :key="item.nameCommmand" :class="'item_' + item.code">
          <toolbarItemWorkbook
            v-if="item.type !== 4"
            class="item_toolbar"
            :toolbar="item"
            :range-style="rangeStyle"
            @toolbarEvent="toolbarEvent"
          >
          </toolbarItemWorkbook>

          <div v-else class="group_toolbar">
            <div class="header_group" @click="hiddenMenu(item.code)" v-tooltip="item.toolTip">
              <div :class="item.icon"></div>
              <!-- <div class="title">{{}}</div> -->
              <div class="icon24 down-group size-icon_custom"></div>
            </div>
            <transition>
              <div class="item_group" v-show="item.code == codeGroup">
                <toolbarItemWorkbook
                  v-for="itemGroup in item.subItems"
                  :key="itemGroup.nameCommmand"
                  class="item_toolbar"
                  :toolbar="itemGroup"
                  :range-style="rangeStyle"
                  @toolbarEvent="toolbarEvent"
                >
                </toolbarItemWorkbook>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <div class="workbook__toolbar__disable" v-if="lockToolbar"></div>
  </div>
</template>

<script>
import {workbookHelper} from '@/commons/workbook/workbookHelper.js';
import toolbarItemWorkbook from './ToolbarItemWorkbook.vue';
import i18nEnum from '@/i18ns/vi/i18nEnum';
export default {
  name: 'ToolbarWorkbook',
  component: {
    toolbarItemWorkbook,
  },
  props: {
    rangeStyle: {
      default: {},
      type: Object,
    },
    lockToolbar: {
      default: false,
      type: Boolean,
    },
  },
  emits: ['actionToolbar'],
  data() {
    const cachedToolbarItems = JSON.parse(JSON.stringify(workbookHelper.ToolbarWorkbook));
    return {
      cachedToolbarItems,
      codeGroup: '',
      hiddenItems: [],
      dropdownVisible: false,
      hasHiddenItems: false,
      leftToolbar: 0,
      widthToolbar: 0,
    };
  },
  mounted() {
    let me = this;
    this.checkOverflow();
    document.addEventListener('click', me.click_out);

    // Sử dụng ResizeObserver để theo dõi thay đổi kích thước của toolbar
    this.resizeObserver = new ResizeObserver(() => {
      this.checkOverflow();
    });

    // Bắt đầu theo dõi toolbar khi component được mount
    this.resizeObserver.observe(this.$refs.toolbar);

    // Kiểm tra lại khi cửa sổ thay đổi kích thước
    window.addEventListener('resize', this.checkOverflow());
  },
  methods: {
    toolbarEvent(event, type, data) {
      this.codeGroup = '';
      this.$emit('actionToolbar', {data});
    },
    hiddenMenu(code) {
      if (this.codeGroup === code) {
        this.codeGroup = '';
      } else {
        this.codeGroup = code;
      }
    },
    click_out(event) {
      if (!this.$el.contains(event.target)) {
        this.codeGroup = '';
      }
      if (this.$refs.moreToolbar && !this.$refs.moreToolbar.contains(event.target)) {
        this.dropdownVisible = false;
      }
    },
    /**
     * Hàm xác định các item của toolbar đã wrap xuống dòng chưa
     */
    checkOverflow() {
      let me = this;
      if (!me.$refs.toolbar) return;
      const toolbarWidth = me.$refs.toolbar.offsetWidth;
      if (me.widthToolbar === toolbarWidth) return;
      me.widthToolbar = toolbarWidth;
      let totalWidth = 0;
      me.hiddenItems = [];
      me.cachedToolbarItems.forEach(item => {
        totalWidth += me.getSizeToolbar(item);
        if (totalWidth + 120 > toolbarWidth) {
          item.isHidden = true;
          me.hiddenItems.push(item);
        } else {
          item.isHidden = false;
        }
      });
      me.hasHiddenItems = me.hiddenItems.length > 0;
      me.getPostionLeft();
    },
    toggleDropdown() {
      let me = this;
      me.codeGroup = '';
      me.dropdownVisible = !me.dropdownVisible;
    },

    getPostionLeft() {
      let me = this;
      let totalWidth = 0;
      let totalWidthHidden = 0;
      let filteredArr = me.cachedToolbarItems.filter(item => item.isHidden === false);
      filteredArr.forEach(item => {
        totalWidth += me.getSizeToolbar(item);
      });
      me.hiddenItems.forEach(item => {
        totalWidthHidden += me.getSizeToolbar(item);
      });
      me.leftToolbar = totalWidth - totalWidthHidden + 14;
      if (me.leftToolbar < 0) {
        me.leftToolbar = 0;
      }
    },
    // lấy ra size của toolbar
    getSizeToolbar(item) {
      let totalWidth = 0;
      switch (item.type) {
        case i18nEnum.ToolbarItemType.Button:
        case i18nEnum.ToolbarItemType.Group:
        case i18nEnum.ToolbarItemType.ColorPicker:
        case i18nEnum.ToolbarItemType.ButtonDropdown:
          totalWidth = 32;
          break;
        case i18nEnum.ToolbarItemType.Combobox:
          totalWidth = item.width;
          break;

        default:
          totalWidth = 2;
          break;
      }
      return totalWidth;
    },
  },
  beforeDestroy() {
    // Gỡ bỏ sự kiện và dừng theo dõi khi component bị destroy
    window.removeEventListener('resize', this.checkOverflow);

    if (this.resizeObserver) {
      this.resizeObserver.disconnect(); // Dừng theo dõi các thay đổi kích thước
    }
  },
};
</script>

<style lang="scss">
.toolbar-workbook {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  position: relative;
  .more_item {
    cursor: pointer;
    z-index: 1000;
    .toolbar-more_items {
      z-index: 9999;
      background-color: white;
      box-shadow: 0 0 8px 6px rgba(0, 0, 0, 0.16);
      display: flex;
      height: 32px;
      position: absolute;
      align-items: center;
      justify-content: flex-start;
    }
  }
  .more_item:hover {
    background-color: #ebedf0;
  }
  .item_toolbar {
    cursor: pointer !important;
  }
  .group_toolbar {
    position: relative;
    display: inline-block;
    .header_group {
      height: 32px;
      width: 32px;
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: pointer;
      .size-icon_custom {
        width: 16px;
      }
    }
    .header_group:hover {
      background-color: #ebedf0;
    }
    .item_group {
      position: absolute;
      z-index: 1;
      z-index: 9999;
      background-color: white;
      box-shadow: 0 0 8px 6px rgba(0, 0, 0, 0.16);
    }
  }
  .workbook__toolbar__disable {
    background: #e8e7e792 !important;
    position: absolute !important;
    width: 100% !important;
    height: 100% !important;
    top: 0;
    left: 0;
  }
}
</style>